import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2026 Muhammad Anas. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
